import "vidstack/player/styles/default/captions.css";
import {
defineCustomElement,
MediaCaptionsElement
} from "vidstack/elements";

defineCustomElement(MediaCaptionsElement);